import React from "react";

export const SearchBarDesktop = ({ onSearch, setDataSearch, dataSearch }) => {
  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const updateState = (field, text) => {
    setDataSearch({
      ...dataSearch,
      [field]: text,
    });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      setDataSearch({
        ...dataSearch,
        pageIndex: 1,
      });
      onSearch(dataSearch);
    }
  };

  return (
    <>
      <div className="search-new  show-table-main">
        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Mã phiếu</label>
          <input
            type="text"
            className="form-control input-sm"
            placeholder="Mã phiếu"
            value={dataSearch.search}
            onChange={updateTextValue("search")}
            onKeyDown={handleKeyDown}
          />
        </div>

        <div className="input-sm-new input-new-18 search-main-new btn-seach-ds">
          <button type="submit" className="btn btn-info-new" onClick={onSearch}>
            <i className="la la-search"></i>
            <span> &nbsp; Tìm kiếm</span>
          </button>
        </div>
      </div>
    </>
  );
};
